<template>
    <el-dialog
        v-dialogDrag
        ref="etaoDialog"
        class="etaoDialog"
        :title="title"
        :fullscreen="isfullscreen"
        :visible.sync="visible"
        :append-to-body="appendToBody"
        :close-on-click-modal="false"
        :show-close="false"
        :destroy-on-close="destroyOnClose"
        :width="width"
        @closed="() => $emit('closed')"
        center>
        <template v-if="visible">
            <div slot="title" class="medium">
                <div></div>
                <div class="centers"><span>{{ title }}</span></div>
                <div class="icons"  v-if="isHeader">
                    <i :class="isfullscreen? 'el-icon-news' : 'el-icon-full-screen' "
                       style="font-size: 24px" @click="IsFullscreen"></i>
                    <i class="el-icon-close" style="font-size: 24px" @click="closeDialog"></i>
                </div>
                <div v-else></div>
            </div>
            <div class="dialogBody">
                <slot></slot>
            </div>
            <div v-if="isFooter" class="dialogFooter">
                <slot name="footer" solt="footer">
                    <el-button @click="closeDialog">{{ $d('取消') }}</el-button>
                    <el-button type="primary" @click="submitForm">{{ $d('确定') }}</el-button>
                </slot>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import $ from 'jquery'
import eventBus from '@/comp/lib/eventBus'

export default {
    name: 'etao-dialog',
    props: {
        windowId: String,
        width: {
            type: String,
            default: '50%'
        },
        title: {
            type: String,
            default: ''
        },
        isFooter: { // 是否显示脚部
            type: Boolean,
            default: true
        },
        isHeader: { // 是否显示头部
            type: Boolean,
            default: true
        },
        height: String,
        onClose: Function,
        beforeClose: Function,
        fullscreen: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: Array,
            default: () => []
        },
        appendToBody: {
            type: Boolean,
            default: true
        },
        enableDrag: {
            type: Boolean,
            default: true
        },
        shadeClose: {
            type: Boolean,
            default: false
        },
        destroyOnClose: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        visible (val) {
            if (val) {
                const el = this.$refs.etaoDialog.$el.querySelector('.el-dialog')
                el.style.left = 0
                el.style.top = 0
            }
        },
        positions: {
            handler: function () {
                $(`.${this.uid()}`).css({
                    top: this.positions.y,
                    left: this.positions.x
                })
            },
            deep: true
        }
    },
    methods: {
        uid: function () {
            return 'Window' + this['_uid']
        },
        open: function (beforeOpen) {
            beforeOpen && beforeOpen()
            this.$nextTick(() => {
                this.visible = true
            })
        },
        close: function (onClose) {
            this.visible = false
            this.$nextTick(() => {
                onClose && onClose()
            })
        },
        onClosed: function () {
            this.showSlot = !this.destroyOnClose
            this.$emit('closed')
        },
        findParents: function (vm = this, parents = []) {
            if (vm.$parent !== undefined) {
                if (vm.$parent.$options.name === 'etaoWindow') {
                    parents.unshift(vm.$parent.uid())
                }
                return this.findParents(vm.$parent, parents)
            }
            return parents
        },
        readyToClose: function (done) {
            const execute = () => {
                done()
                setTimeout(() => {
                    this.$set(this, 'positions', {
                        x: 0,
                        y: 0
                    })
                }, 1000)
            }
            const close = () => {
                if (this.closeConfirm) {
                    this.etao.message.confirm(this.closeConfirm, this.$d('提示'), execute)
                    return
                }
                execute()
            }
            if (this.beforeClose) {
                this.beforeClose(close)
                return
            }
            close()
        },
        // 关闭弹窗
        closeDialog () {
            this.removeDragEvent()
            this.visible = false
        },
        submitForm () {
            this.$emit('submitForm')
        },
        // 打开弹窗
        openDialog (data) {
            this.visible = true
            this.$set(this, 'data', data || null)
            this.$nextTick(() => {
                if (!this.isfullscreen) {
                    this.bindDragEvent()
                }
            })
        },
        bindDragEvent () {
            const dialogHeaderEl = this.$refs.etaoDialog.$el.querySelector('.el-dialog__header')
            const dragDom = this.$refs.etaoDialog.$el.querySelector('.el-dialog')

            dialogHeaderEl.style.cursor = 'move'

            dialogHeaderEl.onmousedown = (e) => {
                const disX = e.clientX - dialogHeaderEl.offsetLeft
                const disY = e.clientY - dialogHeaderEl.offsetTop

                document.onmousemove = function (e) {
                    const l = e.clientX - disX
                    const t = e.clientY - disY
                    dragDom.style.left = `${l}px`
                    dragDom.style.top = `${t}px`
                }

                document.onmouseup = function () {
                    document.onmousemove = null
                    document.onmouseup = null
                }
            }
        },
        removeDragEvent () {
            const dialogHeaderEl = this.$refs.etaoDialog.$el.querySelector('.el-dialog__header')
            const dragDom = this.$refs.etaoDialog.$el.querySelector('.el-dialog')

            if (dialogHeaderEl && dragDom) {
                dialogHeaderEl.onmousedown = null
                document.onmousemove = null
                document.onmouseup = null
            }
        },
        // 全屏
        IsFullscreen () {
            this.isfullscreen = !this.isfullscreen

            const dragDom = window.document.querySelector(`.el-dialog[aria-label=${this.title}]`)

            dragDom.style.top = '0px'
            dragDom.style.left = '0px'

            if (this.isfullscreen) {
                this.removeDragEvent()
            } else {
                this.bindDragEvent()
            }

            this.$emit('isfullscreen')
        }
    },
    data () {
        return {
            isfullscreen: this.fullscreen ? this.fullscreen : false,
            top: false,
            data: null,
            topParents: null,
            showSlot: false,
            visible: false,
            drag: false,
            children: [],
            positions: {
                x: 0,
                y: 0
            }
        }
    },
    directives: {
        dialogDrag: {
            bind (el, binding, vnode, oldVnode) {
                const dialogHeaderEl = el.querySelector('.el-dialog__header')
                const dragDom = el.querySelector('.el-dialog')
                dialogHeaderEl.style.cursor = 'move'
                // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
                const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)
                // const fixedX =
                // const fixedY =
                dialogHeaderEl.onmousedown = (e) => {
                    // 判断当前是否为全屏状态
                    const path = event.path || (event.composedPath && event.composedPath())
                    const isFull = path.find(s => {
                        if (s.className === undefined) {
                            return false
                        } else {
                            return s.className.indexOf('is-fullscreen') > -1
                        }
                    })
                    if (isFull !== undefined) {
                        return
                    }
                    const isMinix = path.find(s => {
                        if (s.className === undefined) {
                            return false
                        } else {
                            return s.className.indexOf('isminimize') > -1
                        }
                    })
                    if (isMinix !== undefined) {
                        return
                    }
                    // 鼠标按下，计算当前元素距离可视区的距离
                    const disX = e.clientX - dialogHeaderEl.offsetLeft
                    const disY = e.clientY - dialogHeaderEl.offsetTop

                    // 获取到的值带px 正则匹配替换
                    let styL, styT

                    // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
                    if (sty.left.includes('%')) {
                        styL = +document.body.clientWidth * (+sty.left.replace(/%/g, '') / 100)
                        styT = +document.body.clientHeight * (+sty.top.replace(/%/g, '') / 100)
                    } else {
                        styL = +sty.left.replace('px', '')
                        styT = +sty.top.replace('px', '')
                    }

                    document.onmousemove = function (e) {
                        // 通过事件委托，计算移动的距离
                        const l = e.clientX - disX
                        const t = e.clientY - disY
                        // 移动当前元素
                        dragDom.style.left = `${l + styL}px`
                        dragDom.style.top = `${t + styT}px`
                        // const dom = e.path.find(s => s.querySelector('.el-dialog')).children[0]
                        //
                        // if (dom.offsetTop < 0) {
                        //   dragDom.style.top = `0px`
                        // }
                        // if (dom.offsetLeft < 0) {
                        //   dragDom.style.left = `0px`
                        // }

                        // 将此时的位置传出去
                        // binding.value({x:e.pageX,y:e.pageY})
                    }

                    document.onmouseup = function (e) {
                        const dragDom = el.querySelector('.el-dialog')
                        const offsetLeft = dragDom.offsetLeft
                        const offsetTop = dragDom.offsetTop
                        const left = Number(dragDom.style.left.replace('px', ''))
                        const top = Number(dragDom.style.top.replace('px', ''))
                        const windowWidth = window.innerWidth
                        const windowHeight = window.innerHeight - 50
                        const offsetRight = offsetLeft + dragDom.offsetWidth - windowWidth
                        const offsetBottom = offsetTop + dragDom.offsetHeight - windowHeight
                        if (offsetLeft < 0) {
                            dragDom.style.left = (left - offsetLeft) + 'px'
                        }
                        if (offsetTop < 0) {
                            dragDom.style.top = (top - offsetTop) + 'px'
                        }
                        if (offsetRight > 0) {
                            dragDom.style.left = (left - offsetRight) + 'px'
                        }
                        if (offsetBottom > 0) {
                            dragDom.style.top = (top - offsetBottom) + 'px'
                        }
                        document.onmousemove = null
                        document.onmouseup = null
                    }
                }
            }
        }
    },
    mounted () {
        const parents = this.findParents()

        this.drag = parents.length ? false : (this.enableDrag && !this.fullscreen)
        this.topParents = parents.length ? parents[0] : null

        /**
         * 检查自身是否为最上级，若是则拥有操作所有下级的权限
         * @type {boolean}
         */
        this.top = !parents.length
        if (this.top) {
            this.children.push(this.uid())

            eventBus.$on('windowBus' + this.uid(), item => {
                const children = this.children
                const index = children.indexOf(item.uid)

                if (item.status) {
                    children.push(item.uid)
                } else {
                    children.splice(index, 1)
                }

                let reverse = JSON.parse(JSON.stringify(children)).reverse()
                let totalX = 0

                for (let i in reverse) {
                    const winEl = $('.custom-window.' + reverse[i])
                    const winParEl = $('.custom-window.' + reverse[parseInt(i) - 1])

                    const calcX = winParEl.length ? (winParEl.width() - winEl.width()) / 2 : 0
                    const position = winEl.width() + calcX + totalX + 20

                    winEl.css({
                        transform: `translateX(-${i > 0 ? position : 0}px)`,
                        transition: `transform 400ms ease-in-out`
                    })

                    totalX += i > 0 ? position : 0
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.el-dialog {
    margin-top: 10vh !important;
    position: relative;
}

.no_select {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Chrome/Safari/Opera */
    -khtml-user-select: none; /* Konqueror */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently */
}

.isminimize {
    left: 20px;
    bottom: 20px;
    top: auto;
    right: auto;
    overflow: hidden;

    .el-dialog {
        margin: 0 !important;
        width: 240px !important;
        height: 40px;
        top: 0 !important;
        left: 0 !important;
    }

    .el-dialog__header {
        cursor: auto !important;
        .el-dialog__headerbtn {
            display: none;
        }
    }

    .dialogFooter {
        position: absolute;
        bottom: 0;

    }
}

.etaoDialog {
    .is-fullscreen {
        width: 100% !important;
        left: 0 !important;
        top: 0 !important;
        margin-top: 0 !important;
        overflow: hidden;
        position: relative;

        .el-dialog__header {
            cursor: auto !important;
        }

        .el-dialog__body {
            height: 100%;

            .dialogBody {
                height: 100% !important;
                max-height: none !important;
            }
        }

        .dialogFooter {
            position: absolute;
            bottom: 0;
            width: calc(100% - 50px);
            background: #fff;
        }
    }

    .el-dialog {
        .el-dialog__header {
            width: 100%;
            padding: 5px 20px 5px !important;
            display: flex;
            border-bottom: 1px solid #ccc;
            @extend .no_select;
            cursor: auto;

            .medium {
                width: 100%;
                height: 100%;
                display: flex;

                div {
                    flex: 1;
                }

                .centers {
                    span {
                        text-align: center;
                        font-size: 16px;
                        color: #606266;
                    }
                }

                .icons {
                    display: flex;
                    justify-content: flex-end;

                    i {
                        color: #5f6368;
                        font-size: 18px !important;
                        display: block;
                        padding: 0 7px;
                    }

                    i:hover {
                        background: #dcdfe6;
                        cursor: pointer;
                    }

                    .el-icon-close:hover {
                        background: #f00;
                        color: #fff;
                    }
                }
            }

            .horn {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-between;

                div {
                    i {
                        color: #5f6368;
                        font-size: 20px !important;
                    }
                }

                .lefts {
                    flex: 4;
                    margin-top: 3px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                    span {
                        font-size: 16px;
                        color: #606266;
                    }
                }

                .centers {
                    flex: 1;
                }

                .rights {
                    flex: 1;
                }

                i:hover {
                    cursor: pointer;
                    color: #000;
                }
            }

            .el-dialog__headerbtn {
                top: 0;
                font-size: 24px;
            }
        }

        .el-dialog__body {
            padding: 1px !important;

            .dialogBody {
                max-height: calc(80vh - 50px);
                box-shadow: inset 0px 1px 0px 0px #f2f6f5;
                overflow: auto;
                padding: 20px 25px 20px;
                background: #f7f9fc;

                &::-webkit-scrollbar {
                    width: 4px;
                    height: 8px;
                }

                &::-webkit-scrollbar-thumb {
                    background: transparent;
                    border-radius: 4px;
                }

                &:hover::-webkit-scrollbar-thumb {
                    background: hsla(0, 0%, 53%, .4)
                }

                &:hover::-webkit-scrollbar-track {
                    background: hsla(0, 0%, 53%, .1)
                }
            }

            .dialogFooter {
                padding: 10px 15px;
                border-top: 1px solid #ccc;
                text-align: right;

                .el-button {
                    padding: 7px 15px;
                }
            }
        }
    }

    .etaoDialog {
        // display: flex;
        // justify-content: center;
        .el-select {
            width: 100%;
        }

        .el-date-editor {
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/comp/etao-dialog.vue